var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.743,
    height: 14.18,
    viewBox: "0 0 10.743 14.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "waiting-svgrepo-com",
    d: "M46.264,13.226h-.844V11.719a4.742,4.742,0,0,0-2.334-3.91.86.86,0,0,1-.309-.719.86.86,0,0,1,.309-.719,4.743,4.743,0,0,0,2.334-3.91V.954h.844a.477.477,0,0,0,0-.954H36.475a.477.477,0,0,0,0,.954h.844V2.461a4.742,4.742,0,0,0,2.333,3.91.86.86,0,0,1,.309.719.86.86,0,0,1-.309.719,4.742,4.742,0,0,0-2.334,3.91v1.507h-.844a.477.477,0,0,0,0,.954h9.788a.477.477,0,0,0,0-.954ZM40.892,5.269a.477.477,0,1,1,.954,0v.843a.477.477,0,0,1-.954,0Zm.14,3.036a.477.477,0,1,1-.14.337A.481.481,0,0,1,41.032,8.305Zm-2.6,4.925c.389-1.476,2.395-3.081,2.645-3.277a.477.477,0,0,1,.588,0c.25.2,2.256,1.8,2.645,3.277Z",
    transform: "translate(-35.998)",
    fill: "#efd47b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in_progress.40878a2e3a13e331f81ebbf83eb751ad.svg";
export { ForwardRef as ReactComponent };